import { lazy } from 'react';
import {
    CREATE_PERMISSION,
    CONTACT_AUTH,
    READ_PERMISSION,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';
import { PermissionsGuard } from './components';

export const Routes = [
    {
        exact: true,
        path: '/management/contacts',
        guard: PermissionsGuard,
        roles: {
            permission: CONTACT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/contacts/ContactsListView')),
    },
];
